import { useAppSelector } from "newui/store/hooks";

import { selectIsExecutiveViewActive } from "newui/features/Auth/authSelectors";

export const useIsReadOnlyMode = (): boolean => {
	return useAppSelector(selectIsExecutiveViewActive);
};
